import { render } from "./TemplateBookBooking.vue?vue&type=template&id=f5d65d46&scoped=true"
import script from "./TemplateBookBooking.vue?vue&type=script&lang=js"
export * from "./TemplateBookBooking.vue?vue&type=script&lang=js"

import "./TemplateBookBooking.vue?vue&type=style&index=0&id=f5d65d46&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f5d65d46"

export default script